import { useState } from "react";
import { Image as ImageIcon, Images, MessageCircle, Settings } from "lucide-react";
import ChatPanel from "@/components/studio/ChatPanel";
import ImagePanel from "@/components/studio/ImagePanel";
import GalleryPanel from "@/components/studio/GalleryPanel";
import SettingsPanel from "@/components/studio/SettingsPanel";

const tabs = [
  { id: "chat", label: "Voix & Chat", icon: MessageCircle },
  { id: "images", label: "Images", icon: ImageIcon },
  { id: "galerie", label: "Galerie", icon: Images },
  { id: "reglages", label: "Réglages", icon: Settings },
];

export default function Studio() {
  const [tab, setTab] = useState("chat");
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
      <aside className="lg:col-span-3 min-w-0">
        <h1 className="font-serif text-4xl mb-6">Studio</h1>
        <nav className="flex lg:flex-col gap-2 overflow-x-auto">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button key={id} data-testid={`studio-tab-${id}`} onClick={() => setTab(id)}
              className={`flex items-center gap-3 px-4 py-3 rounded-2xl whitespace-nowrap transition-colors ${tab === id ? "bg-[var(--text)] text-[var(--bg)]" : "text-[var(--text-secondary)] hover:bg-[var(--surface-subtle)]"}`}>
              <Icon size={18} /> {label}
            </button>
          ))}
        </nav>
      </aside>
      <section className="lg:col-span-9 min-w-0">
        <div className={tab === "chat" ? "" : "hidden"}><ChatPanel /></div>
        {tab === "images" && <ImagePanel onDone={() => setTab("galerie")} />}
        {tab === "galerie" && <GalleryPanel />}
        {tab === "reglages" && <SettingsPanel />}
      </section>
    </div>
  );
}
